import { useEffect } from "react";
import { DEBOUNCE_DELAY, USER_FETCH_LIMIT } from "../constants/GroupedUserListConstants";
export const useFetchUsers = (chatClient, currentUserId, searchValue, setUsers, setLoading) => {
  useEffect(() => {
    let active = true;

    const fetchUsers = () => {
      setLoading(true);
      chatClient
        .queryUsers(
          { id: { $ne: currentUserId }, share: true, is_active: true },
          { id: 1 },
            { limit: USER_FETCH_LIMIT }
        )
        .then((response) => {
          if (active) setUsers(response.users);
        })
        .catch((error) => {
          console.error("Error fetching users:", error);
          if (active) setUsers([]);
        })
        .finally(() => {
          if (active) setLoading(false);
        });
    };

    const searchUsers = () => {
      setLoading(true);
      const delayDebounce = setTimeout(() => {
        chatClient
          .queryUsers(
            {
              name: { $autocomplete: searchValue },
              id: { $ne: currentUserId },
              is_active: true,
            },
            { id: 1 },
            { limit: 25 }
          )
          .then((response) => {
            if (active) setUsers(response.users);
          })
          .catch((error) => {
            console.error("Error fetching users:", error);
            if (active) setUsers([]);
          })
          .finally(() => {
            if (active) setLoading(false);
          });
      }, DEBOUNCE_DELAY);
      return () => clearTimeout(delayDebounce);
    };

    if (!searchValue) {
      fetchUsers();
    } else if (searchValue.length >= 3) {
      searchUsers();
    }

    return () => {
      active = false;
    };
  }, [searchValue, chatClient, currentUserId, setUsers, setLoading]);
};